import React from 'react';

import html2canvas from 'html2canvas';
import { QRCodeSVG } from 'qrcode.react';

import { CanvaWrapper, StationIdLabel } from './styles';

export interface IStationQRCode {
  chargerUuid: string;
  chargerPk: number;
  chargeBoxId: string;
  isTerminal?: boolean;
  containerId: string;
}

export interface IQRCode extends Partial<IStationQRCode> {
  size?: number;
  value: string;
  chargerPkText: string;
}

const QRCODE_SIZE = 80;
const QRCODE_DOWNLOAD_SIZE = 600;

const QRCode = ({ chargerPkText, size, value }: IQRCode) => (
  <>
    <QRCodeSVG value={value} size={size || QRCODE_SIZE} />
    <StationIdLabel>{chargerPkText}</StationIdLabel>
  </>
);

const StationQRCode = ({
  chargerUuid,
  chargerPk,
  chargeBoxId,
  isTerminal,
  containerId,
}: IStationQRCode) => {
  const chargerPkText = String(chargerPk).padStart(6, '0');

  // Lido no render, nao no load do modulo: na primeira sessao o useApp so grava
  // esses hosts depois que o bundle ja carregou, e o QR saia https://null/ (MV2-2031).
  const value = isTerminal
    ? `https://${localStorage.getItem(
        'terminalpayment-host',
      )}/?chargerBoxId=${chargerUuid}`
    : `https://${localStorage.getItem(
        'deeplinking-host',
      )}/station/${chargerPk}/${chargerUuid}`;

  const download = () => {
    const qrCodeContainer = document.getElementById(containerId) as HTMLElement;

    html2canvas(qrCodeContainer, {
      onclone: (clonedDocument: any) => {
        const qrCodeContainerCloned =
          clonedDocument?.getElementById(containerId);

        if (qrCodeContainerCloned) {
          qrCodeContainerCloned.style.display = 'flex';
        }
      },
    }).then((canvas) => {
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/jpg');
      link.download = `QrCode-${chargeBoxId}.png`;
      link.click();
    });
  };

  return (
    <>
      <div onClick={download}>
        <QRCode value={value} chargerPkText={chargerPkText} />
      </div>
      {/* download element */}
      <CanvaWrapper id={containerId}>
        <QRCode
          value={value}
          chargerPkText={chargerPkText}
          size={QRCODE_DOWNLOAD_SIZE}
        />
      </CanvaWrapper>
    </>
  );
};

export default StationQRCode;
